import { HTMLAttributes, forwardRef } from 'react';

import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core';

import classNames from 'classnames';

import { useCommentApi } from '@spotify/plugin-confidence-comments-react';

import CommentInput from './CommentInput';
import CommentList from './CommentList';
import { useActivityFeedItemContext } from './context';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(2),
      paddingTop: theme.spacing(2),
      borderTop: `1px solid ${theme.palette.divider}`,
    },
  });

export interface CommentsProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'classes' | 'children'>,
    WithStyles<typeof styles> {}

const Comments = forwardRef<HTMLDivElement, CommentsProps>((props, ref) => {
  const { className, classes, ...rest } = props;
  const { showComments, activity } = useActivityFeedItemContext();

  const { addComment } = useCommentApi(activity.name);

  if (!showComments) return null;

  return (
    <div ref={ref} className={classNames(classes.root, className)} {...rest}>
      <CommentList />
      <CommentInput
        onSubmit={async content => {
          await addComment(content);
        }}
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus
      />
    </div>
  );
});

Comments.displayName = 'ActivityFeedItem.Comments';

export default withStyles(styles)(Comments);
